import ViewAs from './ViewAs';

export default ViewAs;
